varying vec2 vUv;

uniform sampler2D uPerlin;
uniform float uTime;

void main() {
  float floatingArea = step(0.1,vUv.y - 0.45);
  float fallingArea = 1.0 - floatingArea;


  //falling water
  vec2 fallingUv = vUv;
  fallingUv.y += uTime * 0.8;
  fallingUv.y /= 3.0;
  fallingUv.x *= 2.8;
  float fallingPerlin = texture2D(uPerlin, fallingUv).r;
  fallingPerlin = 1.0 - step(0.4, fallingPerlin);
  fallingPerlin = fallingPerlin * fallingArea;
  
  //floating water
  vec2 floatingUv = vUv;
  floatingUv.y += uTime * 0.3;
  floatingUv *= 1.2;
  float floatingPerlin = texture2D(uPerlin, floatingUv).r;
  floatingPerlin = 1.0 - step(0.38, floatingPerlin);
  floatingPerlin = floatingPerlin * floatingArea;


  // Divider
  vec2 dividerUv = vUv;
  dividerUv.x *= 2.0;
  dividerUv.y -= 0.09;
  float dividerPerlin = texture2D(uPerlin, dividerUv + (uTime * 0.25)).r;
  float divider = step(0.96,1.0 - abs((dividerUv.y + (dividerPerlin * 0.1)) - 0.5));
  float bottomDivider = 1.0 - step( 0.17,abs(vUv.y + dividerPerlin * 0.15));
  
  vec3 color = vec3(floatingPerlin + fallingPerlin);
  vec3 colorOne = vec3(0.1882, 0.5451, 0.7216);
  vec3 colorTwo = vec3(0.5843, 0.7765, 0.8627);

  color = mix(colorOne, colorTwo, color.r);
  color = mix(color, colorTwo, divider + bottomDivider);

  gl_FragColor = vec4(color,1.0);

}